module.exports = __webpack_public_path__ + "media/images/ic-map-circle-hover-yellow-bfae4408.svg";